import { Box, Button, Stack, Typography } from '@mui/material';

import { cardSx } from '../shell/tokens';

export function IntakeKickoffCard({ onScheduleClick }: { onScheduleClick?: () => void }) {
  return (
    <Box component="aside" aria-label="Implementation kickoff" sx={cardSx}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{ alignItems: { sm: 'center' }, justifyContent: 'space-between' }}
      >
        <Box>
          <Typography variant="h6" component="h2">
            Meet your implementation team
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Choose a time for your kickoff. Scheduling a meeting does not change your setup
            progress.
          </Typography>
        </Box>
        <Button
          variant="outlined"
          href="https://calendly.com/d/d3zg-tpb-b84/implementation-kickoff"
          target="_blank"
          rel="noopener noreferrer"
          onClick={onScheduleClick}
          sx={{ flexShrink: 0 }}
        >
          Schedule kickoff (new tab)
        </Button>
      </Stack>
    </Box>
  );
}
